import SpeedIcon from '@mui/icons-material/Speed';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { lighten } from 'polished';
import { defineMessage, useIntl } from 'react-intl';

const efficiencyTooltipOnMessage = defineMessage({
  id: 'fragments.transcription.v2.efficiencyTooltipOn',
  defaultMessage: 'Eficiencia por palabra: activado',
});

const efficiencyTooltipOffMessage = defineMessage({
  id: 'fragments.transcription.v2.efficiencyTooltipOff',
  defaultMessage: 'Eficiencia por palabra: desactivado',
});

type TranscriptionWordEfficiencyActionProps = {
  showWordEfficiency: boolean;
  onWordEfficiencyClick: () => void;
};

/**
 * Renders the per-word efficiency toggle action with active/inactive visual state.
 */
export function TranscriptionWordEfficiencyAction({
  showWordEfficiency,
  onWordEfficiencyClick,
}: TranscriptionWordEfficiencyActionProps) {
  const theme = useTheme();
  const { $t } = useIntl();

  const efficiencyIconButton = (
    <IconButton
      size="small"
      color={showWordEfficiency ? 'success' : 'secondary'}
      sx={{
        bgcolor: showWordEfficiency ? lighten(0.45, theme.palette.success.light) : undefined,
      }}
      onClick={onWordEfficiencyClick}
    >
      <SpeedIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Tooltip
      placement="left"
      title={showWordEfficiency ? $t(efficiencyTooltipOnMessage) : $t(efficiencyTooltipOffMessage)}
    >
      {efficiencyIconButton}
    </Tooltip>
  );
}
